import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MigrationsService } from '@migrations/services/migrations.service';
import {
  IMigrationStatus,
  MigrationState,
  MigrationStatusEvents,
} from '@shared';

@Component({
  selector: 'migrations-last-progress',
  templateUrl: './migrations-last-progress.component.html',
  styleUrls: ['./migrations-last-progress.component.scss'],
})
export class MigrationsLastProgressComponent {
  @Input() progress: IMigrationStatus = null;
  @Input() progressIsLoading = false;
  @Output() updateMigrationProgress = new EventEmitter<{
    proAccountId: string;
    oneAccountId: string;
    sectionId: string;
  }>();

  get events() {
    return this.progress?.events;
  }

  get eventTypes() {
    return Object.keys(this.progress?.events);
  }

  MigrationState = MigrationState;

  constructor(private migrationsService: MigrationsService) {}

  splitOnUppercase(title: string) {
    return title.split(/(?=[A-Z])/).join(' ');
  }

  getMigrationStateClass(state: MigrationState) {
    return this.migrationsService.getMigrationStateClass(state);
  }

  getEventType(type: string) {
    return this.progress?.events[type];
  }

  formatEvents(num: number) {
    return Math.abs(num) > 999
      ? Math.abs(num) < 999999
        ? (Math.sign(num) * Math.round(Math.abs(num) / 100)) / 10 + 'k'
        : (Math.sign(num) * Math.round(Math.abs(num) / 100000)) / 10 + 'm'
      : Math.sign(num) * Math.abs(num);
  }

  percentage(events: MigrationStatusEvents) {
    return ((events.processedEvents / events.totalEvents) * 100).toFixed(1);
  }

  updateProgress(proAccountId, oneAccountId, sectionId) {
    this.updateMigrationProgress.emit({
      proAccountId,
      oneAccountId,
      sectionId,
    });
  }
}
